// BD-931: a parent's anonymisation applies to every tenancy below it, so a child can't switch
// it off while an ancestor has it on. Returns the message to show, or null if the change is allowed.
export function anonymiseReportsBlockReason(tenancy, newValue, ancestorAnonymisesReports) {
    const isChild = tenancy.parentTenancyId > 0;

    if (ancestorAnonymisesReports) {
        return "Anonymise reports is set on a parent tenancy and inherited by its children, it can't be changed here.";
    }
    if (isChild && newValue) {
        return "Anonymise reports can only be switched on at the top-level parent tenancy, which then applies it to all its children.";
    }
    return null;
}
